// src/services/checkout.service.js
import { auth } from "../firebase";

const API = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function authHeader() {
  const u = auth.currentUser;
  if (!u) return {};
  const token = await u.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

function buildCartRecord(cartItems = []) {
  // бекенд чекає z.record({...}) -> обʼєкт, не масив
  const entries = (cartItems || [])
    .filter((it) => it?.id)
    .map((it) => {
      const id = String(it.id); // ✅ variant id
      return [
        id,
        {
          id,
          qty: Math.max(1, Number(it.qty || 1)),
          name: it.name || "",
          price: Number(it.price ?? 0),
          image_url: it.image_url || "",
          image_proxy_url: it.image_proxy_url || "",
        },
      ];
    });

  return Object.fromEntries(entries);
}

export async function checkoutPosOrder({ preset = "dine_in", cartItems = [] } = {}) {
  const headers = await authHeader();

  const u = auth.currentUser;

  const payload = {
    customer: {
      name: u?.displayName || "Guest",
      email: u?.email || "guest@example.com",
      phone: "",
    },
    cart: buildCartRecord(cartItems),
    preset, // "dine_in" | "delivery"
  };

  const res = await fetch(`${API}/odoo/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    // щоб у алерті було нормально видно
    const msg =
      typeof data?.error === "string"
        ? data.error
        : data?.message || `HTTP ${res.status}`;
    console.warn("[checkoutPosOrder] failed:", res.status, data);
    throw new Error(msg);
  }

  return data;
}